import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DataService } from '../../services/data-api.service';
import { catchError, exhaustMap, map, of } from 'rxjs';
import { loadAllCompanies, loadCompaniesFailure, loadCompaniesSuccess } from './company.actions';
import { CompanySearchResponse } from 'src/app/models/viewmodels';

@Injectable()
export class CompaniesEffects {
  loadAllCompanies$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(loadAllCompanies),
        exhaustMap(() => {
          return this.dataService.searchCompanies({IncludeInactive: false}).pipe(
            map((companies: CompanySearchResponse) =>
              loadCompaniesSuccess({ companies: companies.Companies })
            ),
            catchError((error) =>
              of(loadCompaniesFailure({ error }))
            )
          );
        })
      )
    }
  );

  constructor(private actions$: Actions, private dataService: DataService) {
  }
}
